import { VirtuosoGrid } from "react-virtuoso";

import Skeleton from "common/components/ui/Skeleton";
import { Tag } from "common/components/ui/Tag";

import { AUDIENCE_PROFILE_STATES } from "../../../constants";
import ProfileCard from "../../ProfileCard";

import type { Dispatch, JSX, SetStateAction } from "react";
import type { AudienceProfile } from "../../../types";

interface AudienceListProps {
  audience: AudienceProfile[];
  isLoading: boolean;
  selectedProfiles: string[];
  setSelectedProfiles: Dispatch<SetStateAction<string[]>>;
  openLeadPreview: (leadId: string) => void;
}

export default function AudienceList({
  audience,
  isLoading,
  selectedProfiles,
  setSelectedProfiles,
  openLeadPreview,
}: AudienceListProps) {
  return (
    <VirtuosoGrid
      customScrollParent={document.getElementById("content-scroll")}
      totalCount={audience.length}
      listClassName="grid md:grid-cols-2 xl:grid-cols-3 gap-3 pb-3"
      itemClassName="flex"
      itemContent={(index) => {
        const profile = audience[index];
        const isSelected = selectedProfiles.includes(profile.urn);

        function onSelect() {
          if (isSelected) {
            setSelectedProfiles(
              selectedProfiles.filter(
                (selectedProfile) => selectedProfile !== profile.urn,
              ),
            );
          } else {
            setSelectedProfiles([...selectedProfiles, profile.urn]);
          }
        }

        let tagComponent: JSX.Element;
        if (isLoading) {
          tagComponent = <Skeleton className="ml-auto h-6 w-20" />;
        } else if (profile.state) {
          const { tagVariant, label } = AUDIENCE_PROFILE_STATES.find(
            ({ states }) => states.includes(profile.state),
          );

          tagComponent = (
            <Tag variant={tagVariant} className="ml-auto">
              {label}
            </Tag>
          );
        }

        return (
          <ProfileCard
            profile={profile}
            isLoading={isLoading}
            isSelected={isSelected}
            onSelect={onSelect}
            openPreview={openLeadPreview}
          >
            {tagComponent}
          </ProfileCard>
        );
      }}
    />
  );
}
